//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defaultBlockProps, getReviews } from "~/helpers/data";

export default {
    name: "BowComponent",
    props: {
        ...defaultBlockProps,

        reviews: {
            default: () => [
                {
                    author: "Francesca",
                    text: "Nullam vel enim et nibh sagittis posuere a non est. Aliquam sodales accumsan augue, quis sagittis tortor semper ac.",
                    link: null,
                },
                {
                    author: "Andrea",
                    text: "Curabitur sagittis sapien tellus, in accumsan lacus ornare et. Phasellus posuere quam eros, ut commodo massa dictum id. Nullam pulvinar rhoncus lobortis.",
                    link: null,
                },
                {
                    author: "Cristian",
                    text: "Maecenas porttitor, lectus id porttitor venenatis, sem enim suscipit mauris, id hendrerit augue magna eget nisi.",
                    link: null,
                },
            ],
            type: Array,
        },
    },
    data: () => ({
        list: [],
    }),
    async fetch() {
        if (this.reviews && this.reviews.length > 0) {
            this.list = await getReviews(this.$axios, this.reviews);
        }
    },
    mounted() {
        this.$nuxt.$emit("update-locomotive");
    },
};
